import { VendorCategoryUpdatePage } from '@/features/vendor-category/pages/VendorCategoryUpdate'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor-category/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor_category.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorCategoryUpdatePage,
})
